<h3 class="title configurator-title">{{ 'workbench.colors.title' | translate }}</h3>

<ng-casto-loader
  *ngIf="!isGroupMaterialConfigurationActive() && !isPlanMaterialConfigurationActive()"></ng-casto-loader>

<!-- Groupes -->
<div class="config-container shadow" *ngIf="isGroupMaterialConfigurationActive()">
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{
      active: subStep === 1,
    }"
    (click)="toggleCollapse(1)">
    {{ 'workbench.colors.groups' | translate }}
  </h4>

  <div class="collapse-block" *ngIf="subStep === 1 && isGroupMaterialConfigurationActive()">
    <ng-workbench-color-groups-plans
      *ngFor="let group of configuration.workbenchConfigurationGroups"
      [collapseIsVisible]="displayedGroupIndex == group.displayOrder"
      [planOrGroup]="group"
      [materials]="materials"
      (onPlanOrGroupSelected)="toggleCollapseGroup($event, group.displayOrder)"
      (onMaterialChanged)="checkIfSplashbackIsNeeded()"></ng-workbench-color-groups-plans>
  </div>
</div>

<!-- Formes -->
<div class="config-container shadow mt-4" *ngIf="isPlanMaterialConfigurationActive()">
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{
      active: subStep === 2,
    }"
    (click)="toggleCollapse(2)">
    {{ 'workbench.colors.plans' | translate }}
  </h4>

  <div class="collapse-block" *ngIf="subStep === 2">
    <ng-workbench-color-groups-plans
      *ngFor="let plan of availablePlans"
      [collapseIsVisible]="displayedPlanIndex == plan.displayOrder"
      [planOrGroup]="plan"
      [materials]="materials"
      (onPlanOrGroupSelected)="toggleCollapsePlan($event, plan.displayOrder)"
      (onMaterialChanged)="checkIfSplashbackIsNeeded()"></ng-workbench-color-groups-plans>
  </div>
</div>
